module.exports = __webpack_public_path__ + "assets/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVI-2df8d1.woff2";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/GoogleFonts/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4gaVI.woff2
// module id = 858
// module chunks = 2